import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./assets/styles/index.css";
import App from "./App.tsx";
import "temporal-polyfill/global";

createRoot(document.getElementById("root")!).render(
	<StrictMode>
		<App />
	</StrictMode>,
);

if (!window.isSecureContext) {
	console.warn([
		"This app is running in an insecure context. Some features may not work as expected.",
		"Use chrome://flags/#unsafely-treat-insecure-origin-as-secure if needed",
	]);
	alert(
		"This app requires a secure context (HTTPS) to function properly. Please access it over HTTPS.",
	);
}
